import { useHookstate } from "@hookstate/core";
import React, { useEffect, useRef, useState } from "react";
import { allCountries, currentInstallation, validateTel } from "../ScrbTools";
import { I18n } from "aws-amplify";
import AdresseAutoComplete from "../AdresseAutoComplete";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Messages } from 'primereact/messages';
import { InputSwitch } from "primereact/inputswitch";
import classNames from "classnames";
import ConditionalComponent from "../ConditionalComponent";
import { installationRules } from "../Rules";
import PropTypes from "prop-types";
import { Dropdown } from "primereact/dropdown";
import { isEmail } from "../../../Utils";

Emplacement.propTypes = {
    editable: PropTypes.bool.isRequired
}

function Emplacement(props) {

    const installation = useHookstate(currentInstallation);
    const countries = useHookstate(allCountries).get();
    const [foundAdress, setFoundAdress] = useState(null);
    const [foundAdressOwner, setFoundAdressOwner] = useState(null);

    const msgUserAddress = useRef(null);
    const msgOwnerAddress = useRef(null);

    useEffect(() => {
        if (foundAdress?.details) {
            msgUserAddress.current.show([
                { life: 5000, severity: 'warn', summary: I18n.get("warning"), detail: I18n.get("confirmAddress"), closable: true },
            ]);
            const details = foundAdress.details;
            let ville = ""
            if (details.find(detail => detail.types.includes("locality"))) {
                ville = details.find(detail => detail.types.includes("locality")).long_name;
            }
            else if (details.find(detail => detail.types.includes("sublocality_level_1"))) {
                ville = details.find(detail => detail.types.includes("sublocality_level_1")).long_name;
            }
            else if (details.find(detail => detail.types.includes("administrative_area_level_1"))) {
                ville = details.find(detail => detail.types.includes("administrative_area_level_1")).long_name;
            }
            updateAdress("address", {
                country: details.find(detail => detail.types.includes("country"))?.short_name || "",
                street: details.find(detail => detail.types.includes("route"))?.long_name || "",
                number: details.find(detail => detail.types.includes("street_number"))?.long_name || "",
                boitePostal: details.find(detail => detail.types.includes("postal_code"))?.long_name || "",
                localite: ville,
                codePostal: details.find(detail => detail.types.includes("postal_code"))?.long_name || ""
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [foundAdress]);

    useEffect(() => {
        if (foundAdressOwner?.details) {
            msgOwnerAddress.current.show([
                { life: 5000, severity: 'warn', summary: I18n.get("warning"), detail: I18n.get("confirmAddress"), closable: true },
            ]);
            const details = foundAdressOwner.details;
            let ville = ""
            if (details.find(detail => detail.types.includes("locality"))) {
                ville = details.find(detail => detail.types.includes("locality")).long_name;
            }
            else if (details.find(detail => detail.types.includes("sublocality_level_1"))) {
                ville = details.find(detail => detail.types.includes("sublocality_level_1")).long_name;
            }
            else if (details.find(detail => detail.types.includes("administrative_area_level_1"))) {
                ville = details.find(detail => detail.types.includes("administrative_area_level_1")).long_name;
            }
            updateAdress("addressOwner", {
                country: details.find(detail => detail.types.includes("country"))?.short_name || "",
                street: details.find(detail => detail.types.includes("route"))?.long_name || "",
                number: details.find(detail => detail.types.includes("street_number"))?.long_name || "",
                boitePostal: details.find(detail => detail.types.includes("postal_code"))?.long_name || "",
                localite: ville,
                codePostal: details.find(detail => detail.types.includes("postal_code"))?.long_name || ""
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [foundAdressOwner]);

    const updateAdress = (key, value) => {
        installation.set(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const onChange = (event) => {
        installation.set(prev => ({
            ...prev,
            [event.target.id]: event.target.value
        }));
    }

    const personnedeContact = () => {
        return (
            <FloatLabel>
                <InputText
                    id="contactNom"
                    value={installation.get().contactNom || ""}
                    onChange={onChange}
                    className={classNames("w-full", { "p-invalid": !installation.get().contactNom })}
                    disabled={!props.editable}
                    maxLength={100}
                />
                <label htmlFor="contactNom">{I18n.get("contactNom")}</label>
            </FloatLabel>
        )
    }

    return (
        <div className="flex flex-column">
            <div className="flex flex-column pl-2">
                <h2 className="text-xl font-semibold mb-4">
                    <i className="fa-light fa-house mr-2"></i>
                    {I18n.get("utilisateur")}
                </h2>
                <div className="flex flex-column gap-4 pt-1 w-full">
                    <div className="w-full">
                        <FloatLabel>
                            <InputText
                                id="nom"
                                value={installation.get().nom || ""}
                                onChange={onChange}
                                className={classNames("w-full", { "p-invalid": !installation.get().nom })}
                                autoComplete="off"
                                disabled={!props.editable}
                                maxLength={100}
                            />
                            <label htmlFor="nom">{I18n.get("nom")}</label>
                        </FloatLabel>
                    </div>
                    <div className="w-full">
                        <FloatLabel>
                            <InputText
                                id="mail"
                                value={installation.get().mail || ""}
                                onChange={onChange}
                                className={classNames(
                                    "w-full",
                                    { "p-invalid": !installation.get().mail || !isEmail(installation.get().mail) }
                                )}
                                autoComplete="off"
                                disabled={!props.editable}
                                maxLength={100}
                                tooltip={I18n.get("mailTooltip")}
                                tooltipOptions={{ position: 'top' }}
                            />
                            <label htmlFor="mail">{I18n.get("mail")}</label>
                        </FloatLabel>
                    </div>
                    <div className="w-full pb-4">
                        <FloatLabel>
                            <InputText
                                id="tel"
                                value={installation.get().tel || ""}
                                onChange={onChange}
                                className={classNames(
                                    "w-full",
                                    { "p-invalid": installation.get().tel && !validateTel(installation.get().tel) }
                                )}
                                autoComplete="off"
                                disabled={!props.editable}
                                maxLength={20}
                            />
                            <label htmlFor="tel">{I18n.get("tel")}</label>
                        </FloatLabel>
                    </div>
                </div>
                <AdresseAutoComplete
                    setFoundAdress={setFoundAdress}
                    scope="address"
                    disabled={!props.editable}
                    componentRestrictions={{ country: "LU" }}
                />
                <div className="flex flex-column lg:flex-row w-full">
                    <div className="w-full lg:w-1 pt-4">
                        <FloatLabel>
                            <InputText
                                id="codePostal"
                                value={installation.get().address?.codePostal || ""}
                                onChange={(e) => {
                                    installation.address.codePostal.set(e.target.value);
                                }}
                                className={classNames("w-full", { "p-invalid": !installation.get().address?.codePostal })}
                                autoComplete="off"
                                disabled={!props.editable}
                                maxLength={50}
                            />
                            <label htmlFor="codePostal">{I18n.get("codePostal")}</label>
                        </FloatLabel>
                    </div>
                    <div className="w-full lg:w-11 lg:pl-6 pt-4 ">
                        <FloatLabel>
                            <InputText
                                id="localite"
                                value={installation.get().address?.localite || ""}
                                onChange={(e) => {
                                    installation.address.localite.set(e.target.value);
                                }}
                                className={classNames("w-full", { "p-invalid": !installation.get().address?.localite })}
                                autoComplete="off"
                                disabled={!props.editable}
                                maxLength={50}
                            />
                            <label htmlFor="localite">{I18n.get("localite")}</label>
                        </FloatLabel>
                    </div>
                </div>
                <Messages ref={msgUserAddress} />
                <div className="flex flex-row pt-5">
                    <label>{I18n.get("ownerSame")}</label>&nbsp;
                    <InputSwitch
                        id="ownerSame"
                        checked={installation.get().ownerSame}
                        onClick={(e) => {
                            installation.ownerSame.set(e.target.checked);
                        }}
                        disabled={!props.editable}
                    />
                </div>
                {!installation.get().ownerSame && (
                    <div className="flex flex-column pt-5">
                        <div className="flex flex-column">
                            <h2 className="text-xl font-semibold mb-4">
                                <i className="fa-light fa-user mr-2"></i>
                                {I18n.get("proprietaire")}
                            </h2>
                            <div className="flex flex-column pt-1 gap-4 w-full">
                                <div className="w-full">
                                    <FloatLabel>
                                        <InputText
                                            id="nomOwner"
                                            value={installation.get().nomOwner || ""}
                                            onChange={onChange}
                                            className={classNames("w-full", { "p-invalid": !installation.get().nomOwner })}
                                            autoComplete="off"
                                            disabled={!props.editable}
                                            maxLength={100}
                                        />
                                        <label htmlFor="nomOwner">{I18n.get("nom")}</label>
                                    </FloatLabel>
                                </div>
                                <div className="w-full">
                                    <FloatLabel>
                                        <InputText
                                            id="mailOwner"
                                            value={installation.get().mailOwner || ""}
                                            onChange={onChange}
                                            className={classNames(
                                                "w-full",
                                                {"p-invalid": !installation.get().mailOwner && !isEmail(installation.get().mailOwner)}
                                            )}
                                            autoComplete="off"
                                            disabled={!props.editable}
                                            maxLength={100}
                                            tooltip={I18n.get("mailTooltip")}
                                            tooltipOptions={{ position: 'top' }}
                                        />
                                        <label htmlFor="mailOwner">{I18n.get("mail")}</label>
                                    </FloatLabel>
                                </div>
                                <div className="w-full pb-4">
                                    <FloatLabel>
                                        <InputText
                                            id="telOwner"
                                            value={installation.get().telOwner || ""}
                                            onChange={onChange}
                                            className={classNames("w-full")}
                                            autoComplete="off"
                                            disabled={!props.editable}
                                            maxLength={20}
                                        />
                                        <label htmlFor="telOwner">{I18n.get("tel")}</label>
                                    </FloatLabel>
                                </div>
                            </div>
                            <AdresseAutoComplete
                                setFoundAdress={setFoundAdressOwner}
                                scope="addressOwner"
                                disabled={!props.editable}
                                componentRestrictions={{ country: ['fr', 'be', 'lu', 'de', 'pt'] }}
                            />
                            <div className="flex flex-column lg:flex-row w-full pb-4">
                                <div className="w-full lg:w-1 pt-4">
                                    <FloatLabel>
                                        <InputText
                                            id="codePostalOwner"
                                            value={installation.get().addressOwner?.codePostal || ""}
                                            onChange={(e) => {
                                                installation.addressOwner.codePostal.set(e.target.value);
                                            }}
                                            className={classNames("w-full", { "p-invalid": !installation.get().addressOwner?.codePostal })}
                                            autoComplete="off"
                                            disabled={!props.editable}
                                            maxLength={50}
                                        />
                                        <label htmlFor="codePostal">{I18n.get("codePostal")}</label>
                                    </FloatLabel>
                                </div>
                                <div className="w-full lg:w-11 lg:pl-6 pt-4">
                                    <FloatLabel>
                                        <InputText
                                            id="localiteOwner"
                                            value={installation.get().addressOwner?.localite || ""}
                                            onChange={(e) => {
                                                installation.addressOwner.localite.set(e.target.value);
                                            }}
                                            className={classNames("w-full", { "p-invalid": !installation.get().addressOwner?.localite })}
                                            autoComplete="off"
                                            disabled={!props.editable}
                                            maxLength={50}
                                        />
                                        <label htmlFor="localiteOwner">{I18n.get("localite")}</label>
                                    </FloatLabel>
                                </div>
                            </div>
                            <div className="flex w-full">
                                <div className="w-full">
                                    <FloatLabel>
                                        <Dropdown
                                            value={installation.get().addressOwner?.country || ""}
                                            options={countries.map(country => ({ label: country.label, value: country.value }))}
                                            onChange={(e) => {
                                                installation.addressOwner.country.set(e.value);
                                            }}
                                            filter
                                            className={classNames("w-full", { "p-invalid": !installation.get().addressOwner?.country })}
                                            optionValue="value"
                                            optionLabel="label"
                                            disabled={!props.editable}
                                        />
                                        <label htmlFor="countryOwner">{I18n.get("country")}</label>
                                    </FloatLabel>
                                </div>
                            </div>
                            <Messages ref={msgOwnerAddress} />
                            <ConditionalComponent
                                objState={installation}
                                rules={installationRules}
                                id={["climOnly"]}
                                component={(
                                    <div className="flex pt-4 w-full">
                                        <div className="w-full">
                                            {personnedeContact()}
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Emplacement;